module.exports = __webpack_public_path__ + "img/tietoevry-logo-neutral-cmyk_M.25628418.svg";